module.exports = __webpack_public_path__ + "img/tit.f1c09b9b.svg";